import { createServer } from 'miragejs'
import { mockServer } from '../../mirage.config.js'
import { isDevMode } from '@/utils/envConfigs'

export function setupMirage() {
  if (isDevMode && process.env.VUE_APP_MOCK_MIRAGE) {
    createServer(mockServer)
  }
}
